import { z } from "zod";

const envVariables = z.object({
  APP_BASE_URL: z.string(),
  NEXT_PUBLIC_SANITY_PROJECT_DATASET: z.string(),
  NEXT_PUBLIC_SANITY_PROJECT_ID: z.string(),
  FORMSPARK_FORM_ID: z.string(),
  FORMSPARK_FORM_ID_SUBSCRIBE: z.string(),
  NEXT_PUBLIC_GTM_CONTAINER_ID: z.string(),
  SANITY_REVALIDATE_HOOK_AUTH_USER: z.string(),
  SANITY_REVALIDATE_HOOK_AUTH_SECRET: z.string(),
  SANITY_API_READ_TOKEN: z.string(),
  NEXT_PUBLIC_SANITY_API_VERSION: z.string(),
  NEXT_PUBLIC_PREVIEW_MODE: z.string(),
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string(),
  AIRTABLE_API_KEY: z.string(),
  AIRTABLE_BASE_ID: z.string(),
});

declare global {
  namespace NodeJS {
    interface ProcessEnv extends z.infer<typeof envVariables> { }
  }
}

export const API_VERSION =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2024-07-11";

export const DATASET = assertValue(
  process.env.NEXT_PUBLIC_SANITY_PROJECT_DATASET,
  "Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_DATASET",
);

export const PROJECT_ID = assertValue(
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  "Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID",
);

export const FORM_SPARK_FORM_ID = process.env.FORMSPARK_FORM_ID;
export const FORM_SPARK_FORM_ID_SUBSCRIBE =
  process.env.FORMSPARK_FORM_ID_SUBSCRIBE;

export const APP_BASE_URL = process.env.APP_BASE_URL;

export const NEXT_PUBLIC_GTM_CONTAINER_ID =
  process.env.NEXT_PUBLIC_GTM_CONTAINER_ID;

export const SANITY_REVALIDATE_HOOK_AUTH_USER =
  process.env.SANITY_REVALIDATE_HOOK_AUTH_USER;

export const SANITY_REVALIDATE_HOOK_AUTH_SECRET =
  process.env.SANITY_REVALIDATE_HOOK_AUTH_SECRET;

export const SANITY_API_READ_TOKEN = process.env.SANITY_API_READ_TOKEN;

export const PREVIEW_MODE = process.env.NEXT_PUBLIC_PREVIEW_MODE;
export const USE_CDN = false;
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
